import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable, pipe, tap } from 'rxjs';
import { SimpleResponse } from '../../main/objetos/simple-response';
import { Injectable } from '@angular/core';
import { ConexionesService } from '../../../shared/services/conexiones.service';
import { Venta, PreOrden, FinalizarPreOrden } from '../objects/venta';
import { FmtCalcularRetiros, Retiro } from '../objects/retiro';
@Injectable({
  providedIn: 'root',
})
export class DocumentosService {
  [key: string]: any;
  private baseUrl: string = '';
  private majaBackUrl: string = '';

  constructor(
    private http: HttpClient,
    private conexionesService: ConexionesService
  ) {
    //Subscripción al cambio de conexion
    conexionesService.conexionesRO.subscribe((res) => {
      if (res && res.length > 0) {
        const conexiones = {
          baseUrl: environment.conexiones_nombre.puntoventa,
          majaBackUrl: environment.conexiones_nombre.main,
        };

        Object.entries(conexiones).forEach(([key, apiNombre]) => {
          const conexion: any = conexionesService.buscarConexion(apiNombre);
          this[key] = conexion?.URL;
        });
      }
    });
  }

  obtenerVentas = (
    usuario: string,
    fechaInicio?: string,
    fechaFin?: string
  ): Observable<SimpleResponse> => {
    let url = `${this.baseUrl}/integrations/ventas/usuario/${usuario}`;

    if (fechaInicio && fechaFin) {
      url += `/${fechaInicio}/${fechaFin}`;
    }

    return this.http
      .get(url, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };
  obtenerVentasPorSucursal = (
    sucursal: number,
    fechaInicio?: string,
    fechaFin?: string
  ): Observable<SimpleResponse> => {
    let url = `${this.baseUrl}/integrations/ventas/sucursal/${sucursal}/`;

    if (fechaInicio && fechaFin) {
      url += `${fechaInicio}/${fechaFin}`;
    }
    return this.http
      .get(url, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };
  obtenerVentasPorCaja = (
    caja: string,
    fechaInicio?: string,
    fechaFin?: string
  ): Observable<SimpleResponse> => {
    let url = `${this.baseUrl}/integrations/ventas/caja/${caja}`;

    if (fechaInicio && fechaFin) {
      url += `/${fechaInicio}/${fechaFin}`;
    }

    return this.http
      .get(url, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };

  registrarVenta = (venta: Venta): Observable<SimpleResponse> => {
    return this.http
      .post(`${this.baseUrl}/integrations/ventas/registrar/`, venta, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };

  obtenerMovimientosCajasPorUsuarioMicrosip = (
    usuarioMS: any,
    tipoMovto: any
  ): Observable<SimpleResponse> => {
    return this.http
      .get(
        `${this.baseUrl}/movtos_cajas/obtener_movtos_cajas_por_usuario/${usuarioMS}/${tipoMovto}`,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };

  obtenerMovtosPorCajasPorEmpresa = (
    empresaId: number,
    tipoMovto: string,
    autorizado?: boolean
  ): Observable<SimpleResponse> => {
    let url = `${this.baseUrl}/movtos_cajas/obtener_movtos_cajas_por_empresa/${empresaId}/${tipoMovto}/${autorizado}`;

    return this.http
      .get(url, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };

  obtenerCajasPorAbrirCerrar = (
    sucursal: any,
    tipoMovto: any
  ): Observable<SimpleResponse> => {
    return this.http
      .get(
        `${this.baseUrl}/integrations/cajas/abrir_cerrar/${sucursal}/${tipoMovto}`,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };

  obtenerCajerosPorCajaId = (cajaId: any): Observable<SimpleResponse> => {
    return this.http
      .get(`${this.baseUrl}/integrations/cajeros/caja_id/${cajaId}`, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };

  registrarMovimientoCaja = (movtoCaja: any): Observable<SimpleResponse> => {
    return this.http
      .post(`${this.baseUrl}/movtos_cajas/registrar_movto_caja`, movtoCaja, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };

  verificarAperturaCaja = (
    usuarioId: number,
    empresaId: number
  ): Observable<SimpleResponse> => {
    return this.http
      .get(
        `${this.baseUrl}/movtos_cajas/verificar_apertura/${usuarioId}/${empresaId}`,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };

  obtenerRetirosPorSucursal = (
    sucursalId: number,
    fechaInicio?: string,
    fechaFin?: string,
    depositos?: boolean
  ): Observable<SimpleResponse> => {
    let url = `${this.baseUrl}/integrations/retiros/sucursal/?sucursal_id=${sucursalId}`;
    if (fechaInicio && fechaFin) {
      url += `&fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`;
    }
    if (depositos) {
      url += `&depositos=true`;
    }
    return this.http
      .get<SimpleResponse>(url, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };

  obtenerRetirosPorSucursalDepositos = (
    sucursalId: number,
    administracion?: boolean,
    panamericano?: boolean
  ): Observable<SimpleResponse> => {
    let url = `${this.baseUrl}/depositos/retiros-sucursal?sucursal_id=${sucursalId}`;
    if (administracion) {
      url += `&administracion=true`;
    } else {
      url += `&administracion=false`;
    }

    if (panamericano) {
      url += `&panamericano=true`;
    } else {
      url += `&panamericano=false`;
    }

    return this.http
      .get<SimpleResponse>(url, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };

  obtenerRetirosPorCajaId = (
    cajaId: number,
    sucursalId: any //se utliza para busqueda de retiros por caja y sucursal en microsip
  ): Observable<SimpleResponse> => {
    const fechaActual = new Date().toISOString().slice(0, 10);
    return this.http
      .get(`${this.baseUrl}/integrations/retiros/${cajaId}/${sucursalId}`, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };

  obtenerVentasPorFolio = (folio: any): Observable<SimpleResponse> => {
    return this.http.get<SimpleResponse>(
      `${this.baseUrl}/integrations/ventas/${folio}/detalle`,
      {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      }
    );
  };

  registrarRetiro = (retiro: Retiro): Observable<SimpleResponse> => {
    return this.http
      .post(`${this.baseUrl}/integrations/retiros/registrar/`, retiro, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };

  calcularRetiros = (
    fmtCalcularRetiros: FmtCalcularRetiros
  ): Observable<SimpleResponse> => {
    return this.http
      .post(
        `${this.baseUrl}/integrations/retiros/calcular/`,
        fmtCalcularRetiros,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };

  registrarPreOrden = (preOrden: PreOrden): Observable<SimpleResponse> => {
    return this.http
      .post(`${this.baseUrl}/integrations/pre-ordenes/registrar`, preOrden, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };
  obtenerPreOrdenes = (empresaId: number): Observable<SimpleResponse> => {
    return this.http
      .get(
        `${this.baseUrl}/integrations/pre-ordenes/busqueda?empresaId=${empresaId}`,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };
  obtenerPreOrden = (
    id: number,
    empresaId: number
  ): Observable<SimpleResponse> => {
    return this.http
      .get(
        `${this.baseUrl}/integrations/pre-ordenes/busqueda?empresaId=${empresaId}&id=${id}`,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };

  obtenerPreOrdenPorTelefono = (
    empresaId: number,
    telefono: number
  ): Observable<SimpleResponse> => {
    return this.http
      .get(
        `${this.baseUrl}/integrations/pre-ordenes/busqueda?empresaId=${empresaId}&telefono_cliente=${telefono}`,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };

  actualizarPreOrden = (preOrden: PreOrden): Observable<SimpleResponse> => {
    return this.http
      .put(
        `${this.baseUrl}/integrations/pre-ordenes/actualizar/${preOrden.id}`,
        preOrden,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };
  finalizarPreOrden = (
    finalizarPreOrden: FinalizarPreOrden
  ): Observable<SimpleResponse> => {
    return this.http
      .put(
        `${this.baseUrl}/integrations/pre-ordenes/actualizar/${finalizarPreOrden.id}`,
        finalizarPreOrden,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };
  obtenerCajerosPorUsuarioEmpresa = (
    usuario: number,
    empresa: number
  ): Observable<SimpleResponse> => {
    return this.http
      .get(
        `${this.majaBackUrl}/api/cajeros/usuario/${usuario}/empresa/${empresa}`,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };

  obtenerEmpresasPorUsuario = (
    usuarioId: number
  ): Observable<SimpleResponse> => {
    return this.http
      .get(
        `${this.majaBackUrl}/api/empresas/obtener-empresas-usuario-id/${usuarioId}`,
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };
  obtenerVentaPorId = (ventaId: number): Observable<SimpleResponse> => {
    return this.http
      .get(`${this.baseUrl}/integrations/ventas/${ventaId}/detalle`, {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      })
      .pipe(tap((resp: any) => resp));
  };

  enviarTicketWhatsApp = (
    ventaId: number,
    pais: string,
    telefono: string,
    caja: string,
    correo: string,
    tipoEnvio: string,
    es_regalo: boolean,
    onix: boolean
  ): Observable<SimpleResponse> => {
    return this.http
      .post(
        `${this.baseUrl}/integrations/ventas/${ventaId}/ticket_digital`,
        {
          pais,
          telefono,
          caja,
          correo,
          tipoEnvio,
          es_regalo,
          onix,
        },
        {
          headers: {
            'x-auth': localStorage.getItem('token') || '',
          },
        }
      )
      .pipe(tap((resp: any) => resp));
  };

  obtnerArticulosCambio = (id: Number): Observable<SimpleResponse> => {
    return this.http.get<SimpleResponse>(
      `${this.baseUrl}/integrations/cambios/obtener/articulos/${id}`,
      {
        headers: {
          'x-auth': localStorage.getItem('token') || '',
        },
      }
    );
  };
}
